import { createContext, useReducer, useContext } from 'react';
import { initialTenantsAppState, TenantsAppReducer } from '../../Components/Tenants/TenantsAppReducer';


const TenantsAppContext = createContext();

export const TenantsAppProvider = ({ children }) => {
    const [state, dispatch] = useReducer(TenantsAppReducer, initialTenantsAppState);
    return (
        <TenantsAppContext.Provider value={{ state, dispatch }}>
            {children}
        </TenantsAppContext.Provider>
    );
}

export const useTenantsApp = () => {
    const context = useContext(TenantsAppContext);
    if (!context) {
        throw new Error('useTenantsApp must be used within a TenantsAppProvider');
    }
    return context;
};